module.exports = __webpack_public_path__ + "media/images/workplace/welcome_bg/4-94c4d07e2eee3a35eef8d2e0855619c3.jpg";